// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"_2k5C6","imageWrapper":"_2M9fs","activeVideo":"_3d0uA","hideVideo":"wAb6W","videoSlideWrapper":"_3rVqz"};